import $ from 'jquery';
import {getViewControllerName} from './../general/Util.js';


const getActiveFeedSalesBadge = async function () {

    const productList = document.getElementById('product-list');
	if ( ! productList ) {
		return;
	}
    const articles = productList.getElementsByTagName('article');
    let visibleArticles = [];
    for (let i = 0; i < articles.length; i++) {

        let articleNumber = articles[i].getAttribute('data-eec-id');
        let productprice = articles[i].getAttribute('data-eec-price');
        let sku = articles[i].getAttribute('data-dy-sku');
        let article = {};
        article['anid'] = sku;
        article['productprice'] = productprice;
        if (articleNumber && sku) {
            visibleArticles.push(article);
        }
    }
    const searchParams = new URLSearchParams(window.location.search);

    const exclusiveVoucher = searchParams.get('exclusivevoucher');


    if (visibleArticles.length > 0) {
        await $.ajax({
            url: '/index.php?cl=acl_voucher_extensions_ajax&fnc=getFeedVoucherData',
            method: 'POST',
            data: {
                data: visibleArticles,
                exclusivevoucher: exclusiveVoucher
            },
            success: function (response) {
                try {
                    var parsed = JSON.parse(response);
                    $.each(parsed, function (index, item) {
                        let articleElement = $('[data-eec-id="' + item.articlenumber + '"]');
                        let feedSalesPercentageBadge = articleElement.find('.feedSalesPercentageBadge');

                        feedSalesPercentageBadge.text('-' + item.voucherpercentage + ' extra');
                        feedSalesPercentageBadge.removeClass('en_hidden');
                    });
                } catch (e) {
                }
            }
        });
    }
}

$(document).ready(function () {

    const v_cl = getViewControllerName();

    switch (v_cl) {
        case 'alist':
        case 'searchservice_alist_filter':
            getActiveFeedSalesBadge().then();
            break;
    }
});
